export default __webpack_public_path__ + "static/media/character-seal-sad.e7cb26a7.png";